export default {
  hero: {
    badge: 'Centre de ressources USFans Spreadsheet',
    title: 'USFans Spreadsheet — Trouvez des produits, vendeurs et guides d’achat',
    subtitle: 'Explorez les ressources de la feuille de calcul USFans, les liens produits, les informations vendeurs, les avis, les guides d’expédition, les conseils de contrôle qualité et les informations d’achat pratiques en un seul endroit organisé.',
    ctaExplore: 'Explorer USFans Spreadsheet',
    ctaBuy: 'Acheter maintenant',
  },
  category: {
    title: 'Parcourir les catégories de produits',
    subtitle: 'Accédez directement à n’importe quelle catégorie du site principal en un seul clic.',
    dropdownLabel: 'Sélection rapide de catégorie',
    dropdownPlaceholder: 'Sélectionnez une catégorie...',
    visit: 'Voir la catégorie',
    shoes: 'Chaussures',
    hoodies: 'Hoodies / Pulls',
    tshirts: 'T-Shirts',
    jackets: 'Vestes',
    pants: 'Pantalons / Shorts',
    headwear: 'Couvre-chefs',
    sets: 'Ensembles',
    underwear: 'Sous-vêtements / Caleçons',
    jersey: 'Maillot',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    other: 'Autres articles',
  },
  cta: {
    title: 'Commencez avec USFans Spreadsheet',
    text: 'Explorez les ressources organisées USFans, les avis, les informations d’expédition et les guides d’achat pratiques. Deux liens rapides vous mènent directement au site principal.',
    spread: 'USFans Spreadsheet',
    buyNow: 'Acheter maintenant',
  },
  about: {
    title: 'Qu’est-ce qu’une feuille de calcul USFans ?',
    p1: 'Une feuille de calcul USFans est une façon structurée d’organiser les liens produits, les informations vendeurs, les catégories et les ressources d’achat associées en un seul endroit facile à lire.',
    p2: 'USFansLink aide les utilisateurs à rechercher des produits, des vendeurs, des contrôles qualité, l’expédition, les informations d’entrepôt et les considérations de sécurité avant de passer commande. Il rassemble les ressources les plus utiles pour que vous trouviez ce dont vous avez besoin plus rapidement.',
  },
  resources: {
    title: 'Ressources populaires',
    subtitle: 'Des réponses rapides aux questions que les acheteurs posent le plus avant de commander.',
    reviews: { title: 'Avis USFans', text: 'Comprenez ce qu’il faut vérifier avant d’utiliser un service ou un vendeur.' },
    shipping: { title: 'Frais d’expédition USFans', text: 'Découvrez ce qui peut influencer les frais et délais d’expédition.' },
    coupons: { title: 'Bons de réduction USFans', text: 'Apprenez à trouver et vérifier les coupons et codes de réduction disponibles.' },
    warehouse: { title: 'Entrepôt USFans', text: 'Comprenez le stockage, l’inspection et les processus associés.' },
    legit: { title: 'USFans est-il fiable ?', text: 'Découvrez des contrôles de sécurité pratiques avant d’acheter.' },
  },
  guide: {
    title: 'Nouveau sur USFans ? Commencez ici',
    text: 'Lisez notre guide complet pour débutants afin de comprendre la feuille de calcul, ce qu’il faut vérifier avant de commander et comment éviter les erreurs courantes.',
    cta: 'Lire le guide complet',
  },
  pillar: {
    title: 'Articles et guides',
    subtitle: 'Des guides détaillés sur les sujets les plus importants avant de commander.',
  },
  faq: {
    title: 'Questions fréquentes',
    q1: 'Qu’est-ce qu’une feuille de calcul USFans ?',
    a1: 'Une feuille de calcul USFans est un catalogue organisé de liens produits, catégories, informations vendeurs et ressources d’achat. Elle vous aide à parcourir et comparer des articles en un seul endroit.',
    q2: 'Comment acheter un produit trouvé dans la feuille de calcul ?',
    a2: 'Suivez le lien de la catégorie vers le site principal, trouvez l’article souhaité et terminez le processus d’achat habituel.',
    q3: 'Les informations de la feuille de calcul sont-elles toujours à jour ?',
    a3: 'USFansLink maintient la structure et les liens organisés, mais la disponibilité et les prix sont gérés par le site principal. Vérifiez toujours les détails là-bas avant de commander.',
    q4: 'USFansLink est-il le même site que le site principal ?',
    a4: 'Non. USFansLink est une ressource d’information indépendante qui vous aide à explorer et comprendre la feuille de calcul. Les achats se font sur le site principal.',
  },
};